export const GoogleAdsErrorConnector = () => {
  return <div>Error</div>;
};
